import { Button } from "antd";
import styled from "styled-components";

export const CustomButtonStyledWrapper = styled(Button)`
  box-shadow: none;
  ${({ margin }: { margin?: string }) => {
    return margin ? `margin: ${margin};` : "";
  }}
`;
